<script setup lang="ts">
import LocationTime from './LocationTime.vue';
import CorporationInfo from './CorporationInfo.vue';
import RouteView from './RouteView.vue';
import type TripSegment from '@itinerary/trip/TripSegment';
import { VehicleType } from '@itinerary/trip/types';

interface IProps {
    segment: TripSegment;
    vehicleType: VehicleType;
    international?: boolean;
    inAutoReserve?: boolean;
    mobileView?: boolean;
}
const { segment, mobileView, international, vehicleType, inAutoReserve } =
    defineProps<IProps>();
const showDuration = computed(
    () =>
        (vehicleType === VehicleType.Plane && international) ||
        vehicleType === VehicleType.Train
);
const destinationHasWarning = computed(
    () => segment.firstTrip.destinationHasWarning
);
</script>

<template>
    <div
        class="segment-view-container"
        :class="{ 'in-auto-reserve': inAutoReserve }"
    >
        <CorporationInfo class="co-info" :segment :mobile-view />
        <section
            class="route-section"
            :class="{
                'mobile-view': mobileView,
                'auto-reserve': inAutoReserve,
            }"
        >
            <LocationTime
                :time="segment.departureTime"
                :location="segment.origin"
                :hide-location="inAutoReserve"
            />
            <RouteView :segment :show-duration :full-width="inAutoReserve" />
            <LocationTime
                :time="segment.arrivalTime"
                :location="segment.destination"
                destination
                :hide-location="inAutoReserve"
                :duration-days="segment.durationDays"
                :destination-has-warning
            />
        </section>
    </div>
</template>

<style lang="scss" scoped>
.segment-view-container {
    display: flex;
    align-items: center;
    order: 1;
    &.in-auto-reserve {
        .co-info {
            padding: 0;
        }
        .route-section {
            margin-right: 32px;
            padding: 0;
        }
    }
    @include mobile-only() {
        &:not(.in-auto-reserve) {
            margin-top: 12px;
        }
    }
}

.route-section {
    flex: 1;
    display: flex;
    align-items: flex-start;
    padding: 16px;
    &.auto-reserve:not(.mobile-view) {
        max-width: 270px;
    }
    &.mobile-view {
        flex: 1;
        padding: 0;
    }
    @include mobile-only() {
        flex: 1;
        padding: 0;
    }
}
</style>
